module.exports = __webpack_public_path__ + "img/Weapon_233.c20d53d0.png";